import { render, staticRenderFns } from "./ProductConsultation.vue?vue&type=template&id=f04be812&scoped=true"
import script from "./ProductConsultation.vue?vue&type=script&lang=ts"
export * from "./ProductConsultation.vue?vue&type=script&lang=ts"
import style0 from "./ProductConsultation.vue?vue&type=style&index=0&id=f04be812&prod&lang=scss&scoped=true"
import style1 from "./ProductConsultation.vue?vue&type=style&index=1&id=f04be812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04be812",
  null
  
)

export default component.exports